import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { FAQS } from "@/constants/faqs";
import { Zap, LifeBuoy } from "lucide-react";

function FaqCard({ faq, index }) {
  return (
    <div
      data-testid={`faq-item-${faq.id}`}
      className="bg-cream-card border border-cream-deep rounded-2xl p-6 md:p-7"
    >
      <div className="flex items-start gap-4">
        <span className="shrink-0 h-9 w-9 rounded-xl bg-brand text-white grid place-items-center font-heading font-bold text-sm">
          {index + 1}
        </span>
        <h3 className="font-heading font-bold text-brand text-lg md:text-xl leading-snug pt-1">
          {faq.question}
        </h3>
      </div>

      {/* Quick answer — always visible */}
      <div className="mt-4 rounded-xl bg-brand-light border-l-4 border-coral px-4 py-3.5">
        <div className="label-caps text-coral flex items-center gap-1.5 mb-1">
          <Zap className="h-3.5 w-3.5" /> Quick answer
        </div>
        <p className="text-sm md:text-base text-brand font-medium leading-relaxed">
          {faq.quickAnswer}
        </p>
      </div>

      {/* Expandable detail sections */}
      <Accordion type="multiple" className="mt-2">
        {faq.sections.map((s, i) => (
          <AccordionItem
            key={s.label}
            value={`${faq.id}-${i}`}
            className="border-b border-cream-deep last:border-b-0"
          >
            <AccordionTrigger
              data-testid={`faq-section-${faq.id}-${i}`}
              className={`hover:no-underline font-heading font-semibold ${
                s.help ? "text-coral" : "text-brand"
              }`}
            >
              <span className="flex items-center gap-2">
                {s.help && <LifeBuoy className="h-4 w-4" />}
                {s.label}
              </span>
            </AccordionTrigger>
            <AccordionContent className="space-y-3">
              {s.paragraphs.map((p, j) => (
                <p
                  key={p.slice(0, 60)}
                  className="text-sm md:text-base text-foreground/80 leading-relaxed"
                >
                  {p}
                </p>
              ))}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}

export default function FaqList() {
  const [faqs, setFaqs] = useState(FAQS);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/faqs`).then((r) => { if (Array.isArray(r.data) && r.data.length) setFaqs(r.data); }).catch(() => {});
  }, []);
  return (
    <div data-testid="faq-list" className="space-y-5">
      {faqs.map((faq, i) => (
        <FaqCard key={faq.id} faq={faq} index={i} />
      ))}
    </div>
  );
}
